import React from 'react';
import TextLink from '@prisjakt/ui-text-link';
import { CoreProperty } from '../types';

type StringPropertyProps = {
  property: {
    id: CoreProperty['id'];
    valueId: string | null;
    categoryLink: string | null;
    prettyTable: string | null;
    pathName?: string | null;
  };
};

const StringProperty = ({ property }: StringPropertyProps) => {
  if (property.categoryLink) {
    return (
      <TextLink to={property.categoryLink}>{property.prettyTable}</TextLink>
    );
  }

  if (property.pathName) {
    return <TextLink to={property.pathName}>{property.prettyTable}</TextLink>;
  }

  return <>{property.prettyTable}</>;
};

export default StringProperty;
